
import React, { useState } from "react";
import { getFromLocalStorage } from "../utils/localStorageUtils";
import { currencyData } from "../utils/constants";

const PriceRangeSlider = ({ filter, onChange }) => {
    const minLimit = filter?.prices?.min_price || 0;
    const maxLimit = filter?.prices?.max_price || 5000;

    const initMin = filter?.prices?.selected_min ?? minLimit;
    const initMax = filter?.prices?.selected_max ?? maxLimit;

    const [minPrice, setMinPrice] = useState(initMin);
    const [maxPrice, setMaxPrice] = useState(initMax);

    React.useEffect(() => {
        let min = filter?.prices?.selected_min ?? minLimit;
        let max = filter?.prices?.selected_max ?? maxLimit;

        min = Math.max(minLimit, Math.min(maxLimit, min));
        max = Math.max(minLimit, Math.min(maxLimit, max));

        if (min > max) { [min, max] = [max, min]; }

        setMinPrice(min);
        setMaxPrice(max);
    }, [filter?.prices?.selected_min, filter?.prices?.selected_max, minLimit, maxLimit]);

    const currency = getFromLocalStorage(currencyData);
    const symbol = currency?.currency?.symbol || 'Rs.';

    const handleMinChange = (e) => {
        const gap = (maxLimit - minLimit) * 0.01;
        const value = Math.min(Number(e.target.value), maxPrice - gap);
        setMinPrice(value);
        onChange({ min: value, max: maxPrice });
    };

    const handleMaxChange = (e) => {
        const gap = (maxLimit - minLimit) * 0.01;
        const value = Math.max(Number(e.target.value), minPrice + gap);
        setMaxPrice(value);
        onChange({ min: minPrice, max: value });
    };

    const range = maxLimit - minLimit || 1;
    const leftPct = ((minPrice - minLimit) / range) * 100;
    const rightPct = 100 - ((maxPrice - minLimit) / range) * 100;

    return (
        <div className="price-slider-wrap">
            {/* Track */}
            <div className="prs-track-container">
                <div
                    className="prs-track-fill"
                    style={{ left: `${leftPct}%`, right: `${rightPct}%` }}
                />
                <input
                    type="range"
                    min={minLimit}
                    max={maxLimit}
                    step={(maxLimit - minLimit) / 1000 || 1}
                    value={minPrice}
                    onChange={handleMinChange}
                    className="thumb-left"
                    style={{ zIndex: minPrice > maxLimit - (maxLimit - minLimit) * 0.1 ? 5 : 3 }}
                />
                <input
                    type="range"
                    min={minLimit}
                    max={maxLimit}
                    step={(maxLimit - minLimit) / 1000 || 1}
                    value={maxPrice}
                    onChange={handleMaxChange}
                    className="thumb-right"
                    style={{ zIndex: 4 }}
                />
            </div>

            {/* Labels */}
            <div className="prs-labels mt-3">
                <span className="text-muted small">Price:</span>
                <span className="fw-bold ms-1">
                    {symbol} {Math.round(minPrice)} — {symbol} {Math.round(maxPrice)}
                </span>
            </div>
        </div>
    );
};

export default PriceRangeSlider;
